
import React from 'react';
import DressCode from '../components/DressCode';
import Footer from '../components/Footer';


function Dress() {
  return (
    <>
        <DressCode />
        <Footer />
    </>
  );
}


export default Dress;
